import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentRU = props => {
    return <Aux>
        <SectionHeading priority={1} text='Порядок платежей' classes='' />

        <SectionHeading text='План 1 / Стандартный' classes='' />
        <ul>
            <li>2000 евро невозвратный депозит при бронировании вашего апартамента;</li>
            <li>30% от цены - первый платеж, 14 календарных дней после бронирования, при подписании предварительного договора (депозит входит);</li>
            <li>30% от цены - второй платеж, при подписании акта образца 14;;</li>
            <li>30% от цены - третий платеж, не позднее чем через два месяца после второй платеж;</li>
            <li>10% от цены - четвертый платеж при подписании акта образца 15</li>
        </ul>

        <SectionHeading text='План 2 / 2% скидка с продажной цены' classes='' />
        <ul>
            <li>2000 евро невозвратный депозит при бронировании вашего апартамента;</li>
            <li>50% от цены – первый платеж, 14 календарных дней после резервации, при подписании предварительного договора (депозит входит);</li>
            <li>20% от цены – второй платеж, при подписании акта образца 14;</li>
            <li>20% от цены – третий платеж, не позднее чем через два месяца после второй платеж;</li>
            <li>10% от цены – четвертый платеж при подписании акта образца 15</li>
        </ul>

        <SectionHeading text='План 3 / 5% скидка с продажной цены' classes='' />
        <ul>
            <li>2000 евро невозвратный депозит при бронировании вашего апартамента;</li>
            <li>90% от цены – первый платеж, 14 календарных дней после бронирования, при подписании предварительного договора (депозит входит);</li>
            <li>10% от цены – последний платеж при подписании акта образца 15</li>
        </ul>

        <SectionHeading text='План 4 с кредитом' classes='' />
        <ul>
            <li>15-20% при подписании</li>
            <li>Платежи можно согласовать!</li>
        </ul>

        <SectionHeading text='План 5 пошаговый платеж' classes='' />
        <ul>
            <li>15-20% при подписании</li>
        </ul>
        <p>Платежи можно согласовать!</p>

        <SectionHeading text='Стоимость' classes='' />
        <p>Стоимость апартаментов с учетом НДС: от 777 евро/кв.м.<br />
            Стоимость гаражей с учетом НДС: от 9 600 евро<br />
            Стоимость магазинов с учетом НДС: переговоры</p>

        <SectionHeading text='Планированный срок исполнения' classes='' />
        <p>Акт образца 14 – не позднее 30.04.2019 г.<br />
        Акт образца 15 – не позднее 31.05.2020 г.</p>
    </Aux>
}

export default ContentRU



// WEBPACK FOOTER //
// ./src/routes/Payment/components/ContentRU.js